export const beatPresets = [
  {
    id: "vagus_delta",
    name: "Low Delta",
    frequency: 3,
    label: "Vagus Nerve Activation",
    description: "Stimulates the vagus nerve to promote relaxation and recovery. Ideal for stress relief.",
    color: "red"
  },
  {
    id: "delta",
    name: "Delta",
    frequency: 4,
    label: "Deep Sleep & Relaxation",
    description: "Encourages deep sleep and physical restoration. Best for unwinding and meditation.",
    color: "indigo"
  },
  {
    id: "theta",
    name: "Theta",
    frequency: 5,
    label: "Meditation & Creativity",
    description: "Enhances creativity and intuition. Ideal for light meditation and mental clarity.",
    color: "purple"
  },
  {
    id: "alpha",
    name: "Alpha",
    frequency: 10,
    label: "Calm Focus & Relaxation",
    description: "Promotes calmness and focus. Great for reducing stress and improving concentration.",
    color: "blue"
  },
  {
    id: "beta-low",
    name: "Beta",
    frequency: 16,
    label: "Focus & Productivity",
    description: "Boosts alertness and cognitive performance. Ideal for studying and problem-solving.",
    color: "green"
  },
  {
    id: "gamma",
    name: "Gamma",
    frequency: 40,
    label: "Peak Performance & Learning",
    description: "Supports memory and high-level cognition. Best for intense focus and learning tasks.",
    color: "orange"
  }
];

export const noisePresets = [
  {
    id: "white",
    name: "White Noise",
    label: "White Noise",
    description: "Provides equal energy across all frequencies. Useful for masking distractions and focus.",
    color: "white"
  },
  {
    id: "pink",
    name: "Pink Noise",
    label: "Pink Noise",
    description: "Balances sound energy naturally. Ideal for relaxation and improving sleep quality.",
    color: "pink"
  },
  {
    id: "brown",
    name: "Brown Noise",
    label: "Brown Noise",
    description: "Produces deep, low-frequency tones. Effective for calming the mind and aiding sleep.",
    color: "brown"
  }
];